'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'fire-smoke';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f74b';
var svgPathData = 'M217.4 17.5c1.1-1 2.6-1.5 4.1-1.5 1.5 0 2.9 .5 4 1.5 18.5 16.7 35.8 34.8 51.9 54.3 1.5 1.9 3.8 2.9 6.2 2.9s4.7-1.1 6.2-3c7.4-9.4 15.6-19.3 24.3-27.2 2.3-2.1 5.9-2.1 8.2 0 18.9 17.4 38.4 41.2 53.2 67.2 14.8 26.1 24.5 54 24.5 79.7 0 17.1-3 33.5-8.4 48.8 5.6-.3 11.3-.3 16.9 0 4.9-15.4 7.5-31.8 7.5-48.8 0-29.5-11-60.1-26.6-87.6-15.6-27.6-36.2-52.6-56.3-71.1-8.4-7.7-21.4-7.8-29.8-.1-7.1 6.5-13.8 14.1-19.9 21.5-14.8-17.3-30.6-33.4-47.2-48.4-4.2-3.8-9.4-5.6-14.6-5.7-5.3 0-10.6 1.8-14.9 5.6-24.3 21.8-51.8 50-73.3 81.6-21.5 31.6-37.4 67.4-37.4 104.2 0 17 2.6 33.4 7.5 48.8 5.7-.3 11.4-.3 16.9 0-5.4-15.3-8.3-31.7-8.3-48.8 0-32.3 14.1-64.9 34.7-95.2 20.5-30.2 47-57.4 70.8-78.7zm47.2 116.8c-5.2-3.9-12.1-3.9-17.3 0-19.5 14.6-66.4 53.4-82.1 98.8 7.2-4.4 14.8-8.2 22.6-11.5 5.2-9.5 11.8-18.9 19.3-27.9 17.3-20.7 37.4-37.2 48.9-45.9 11.5 8.7 31.6 25.2 48.9 45.9 7.5 9 14.1 18.3 19.3 27.9 7.8 3.3 15.4 7.1 22.6 11.5-15.7-45.4-62.6-84.2-82.1-98.8zM256 256c-38 0-72.2 16.6-95.7 42.9-14.6-7-31-10.9-48.3-10.9-61.9 0-112 50.1-112 112S50.1 512 112 512l288 0c61.9 0 112-50.1 112-112S461.9 288 400 288c-17.3 0-33.7 3.9-48.3 10.9-23.4-26.3-57.6-42.9-95.7-42.9zm-87.4 58c20.5-25.6 52.1-42 87.4-42s66.9 16.4 87.4 42c2.4 3 6.7 3.9 10.1 2 13.8-7.6 29.6-12 46.5-12 53 0 96 43 96 96s-43 96-96 96l-288 0c-53 0-96-43-96-96s43-96 96-96c16.9 0 32.7 4.3 46.5 12 3.4 1.9 7.7 1 10.1-2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFireSmoke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;